import { render, staticRenderFns } from "./SynonymsReadingEnPreview.vue?vue&type=template&id=8e0cf8d6&lang=pug&"
import script from "./SynonymsReadingEnPreview.vue?vue&type=script&lang=js&"
export * from "./SynonymsReadingEnPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports